"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _createIconComponent = _interopRequireDefault(require("./utils/createIconComponent"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var IconFileBox = (0, _createIconComponent["default"])({
  content: _react["default"].createElement("g", null, _react["default"].createElement("path", {
    d: "M40.95 49h-11.9v-3h11.9v3zm.5-5.22h-12.9a1.77 1.77 0 0 0-1.76 1.76v4a1.77 1.77 0 0 0 1.76 1.76h12.9a1.77 1.77 0 0 0 1.76-1.76v-4a1.77 1.77 0 0 0-1.76-1.76z"
  }), _react["default"].createElement("path", {
    d: "M61.74 53.78a1.45 1.45 0 0 1-1.45 1.45H9.71a1.45 1.45 0 0 1-1.45-1.45V36a1.45 1.45 0 0 1 1.45-1.45h13.36a.1.1 0 0 1 .09.06l1.63 3.62a2.62 2.62 0 0 0 2.38 1.54h15.65a2.62 2.62 0 0 0 2.38-1.54l1.63-3.62a.1.1 0 0 1 .09-.06h13.37A1.45 1.45 0 0 1 61.74 36v17.78zM17 18.28a1.49 1.49 0 0 1 1.33-.82H20v2h-1.51a1.13 1.13 0 0 0-1.13 1.13v6.08H16a1.13 1.13 0 0 0-1.13 1.13V32h-4.78l7-13.77zm33.32 3.45v4.95H19.63v-4.95zm-28.05-7.22h25.46v4.95H22.27v-4.95zm30.64 14.44V32h-6a2.62 2.62 0 0 0-2.38 1.54l-1.63 3.62a.1.1 0 0 1-.09.06H27.18a.1.1 0 0 1-.09-.06l-1.63-3.62A2.62 2.62 0 0 0 23.07 32h-6v-3.1zM50 17.46h1.62a1.49 1.49 0 0 1 1.33.82l7 13.77h-4.77v-4.24A1.13 1.13 0 0 0 54 26.68h-1.4V20.6a1.13 1.13 0 0 0-1.13-1.13H50v-2zM63.69 34L55.2 17.14a4 4 0 0 0-3.58-2.2H50v-1.56a1.13 1.13 0 0 0-1.13-1.13H21.13A1.13 1.13 0 0 0 20 13.38v1.56h-1.62a4 4 0 0 0-3.58 2.2L6.3 34a4 4 0 0 0-.56 2v17.78a4 4 0 0 0 4 4h50.55a4 4 0 0 0 4-4V36a4 4 0 0 0-.6-2z"
  })),
  height: undefined,
  width: undefined
});
IconFileBox.displayName = 'IconFileBox';
var _default = IconFileBox;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@tecuity/sos-icons/react/file-box.js
// module id = 334
// module chunks = 0